import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'


class Section10 extends Component {
  render() {
    return (
      <section id="page_10">
        <div className="container">
          <div className="row">
            <div className="col-xs-offset-1 title">
              先生方の声
            </div>
            <div className="col-sm-3 col-xs-6 content_wrapper wrapper1">
              <div className="content">
                <span className="quotes">“</span>
                　親しみがもてるフォルムで、生徒たちからも「あ、英語で話すロボット！」「やりたい！」などの声が多いです。
                Musioを生徒たちの英語力向上に活用し、その機能に注目していきたいと思います。
                <span className="quotes right-block" style={{float: 'right'}}>”</span>
              </div>
              <div className="writter">
                同志社中学校 英語教師
              </div>
            </div>

            <div className="col-sm-3 col-xs-6 content_wrapper wrapper2">
              <div className="content">
                <span className="quotes">“</span>
                　これまでハードルが高かった授業内での発音チェックや英会話練習が可能になったのが、一番のポイントです。
                昼休みや放課後でも自主的に学習できるよう開放し、アクティブラーニングにつなげることができて、教員からも喜ばれています。
                <span className="quotes right-block" style={{float: 'right'}}>”</span>
              </div>
              <div className="writter text-right">
                柏崎市教育委員会 教育長
              </div>
            </div>

            <div className="col-sm-3 col-xs-6 content_wrapper wrapper3">
              <div className="content">
                <span className="quotes">“</span>
                Musioを展示会で最初に目にしたとき今までなかった存在だと感じ、ぜひ使ってみたいと考えました。
                英語を身につけてもらうには、発話量がとくに重要なため、より良い英語学習につながると思います。

                <span className="quotes right-block" style={{float: 'right'}}>”</span>
              </div>
              <div className="writter text-right">
              戸田市教育委員会 指導担当
              </div>
            </div>
            <div className="col-sm-3 col-xs-6 content_wrapper wrapper4">
              <div className="content">
                <span className="quotes">“</span>
                  Musioを使うのは、「会話それ自体の練習」ではなく、「会話をするための前段階の練習」。
                  Musioとの練習を経て、ネイティブスピーカーの教員との会話やオンライン英会話などへつながっていて良いと思います。
                <span className="quotes right-block" style={{float: 'right'}}>”</span>
              </div>
              <div className="writter text-right">
              明星中学校 英語教師
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section10;



// WEBPACK FOOTER //
// ./src/sections/Section10.js